/**
 * shop-cart.js — DenimByte Cart Page
 * ─────────────────────────────────────────────
 * 1. Qty stepper (inc/dec) — AJAX /cart/change.js
 * 2. Remove item — AJAX /cart/change.js qty=0
 * 3. Live order summary (subtotal, shipping, total, nudge)
 * 4. Header cart badge sync
 */

(function () {
  'use strict';

  var page = document.getElementById('shopCartPage');
  if (!page) return;

  /* Read thresholds from data attributes set by Liquid */
  var FREE_THRESHOLD = parseInt(page.getAttribute('data-threshold') || '7500', 10);
  var SHIPPING_COST  = parseInt(page.getAttribute('data-shipping-cost') || '499', 10);

  /* ══════════════════════════════════════════════
     MONEY FORMATTING
     Shopify stores prices in pence — format as £X.XX
     ══════════════════════════════════════════════ */
  function formatMoney(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  /* ══════════════════════════════════════════════
     UPDATE ORDER SUMMARY
     Recalculates shipping + total after any change
     ══════════════════════════════════════════════ */
  function updateSummary(cart) {
    var subtotal = cart.total_price;
    var shipping = subtotal >= FREE_THRESHOLD ? 0 : SHIPPING_COST;
    var total    = subtotal + shipping;

    var subtotalEl = document.getElementById('cart-subtotal');
    var shippingEl = document.getElementById('cart-shipping');
    var totalEl    = document.getElementById('cart-total');
    var nudgeEl    = document.getElementById('cart-nudge');
    var countLabel = document.getElementById('cart-item-count-label');

    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (totalEl)    totalEl.textContent    = formatMoney(total);

    if (shippingEl) {
      if (shipping === 0) {
        shippingEl.textContent = 'FREE';
        shippingEl.classList.add('shop-cart__summary-val--free');
      } else {
        shippingEl.textContent = formatMoney(shipping);
        shippingEl.classList.remove('shop-cart__summary-val--free');
      }
    }

    if (nudgeEl) {
      if (shipping > 0) {
        var remaining = FREE_THRESHOLD - subtotal;
        nudgeEl.querySelector('strong').textContent = formatMoney(remaining);
        nudgeEl.classList.remove('shop-cart__nudge--hidden');
      } else {
        nudgeEl.classList.add('shop-cart__nudge--hidden');
      }
    }

    /* Update item count in heading */
    if (countLabel) {
      var count = cart.item_count;
      countLabel.textContent = '(' + count + ' ' + (count === 1 ? 'item' : 'items') + ')';
    }

    /* Sync header cart badge */
    updateCartBadge(cart.item_count);

    /* If cart is now empty, reload to show empty state */
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  /* ══════════════════════════════════════════════
     HEADER CART BADGE
     ══════════════════════════════════════════════ */
  function updateCartBadge(count) {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.textContent = count;
    badge.setAttribute('data-cart-count', count);
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  /* ══════════════════════════════════════════════
     UPDATE LINE PRICE IN DOM
     Recalculates line price from unit price × qty
     ══════════════════════════════════════════════ */
  function updateLinePrice(key, qty, cart) {
    /* Find unit price from Shopify's response */
    var unitPrice = 0;
    var unitCompare = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) {
        unitPrice   = cart.items[i].price;
        unitCompare = cart.items[i].compare_at_price || 0;
        break;
      }
    }

    var lineEl    = page.querySelector('.shop-cart__line-price[data-key="' + key + '"]');
    var compareEl = page.querySelector('.shop-cart__compare-line[data-key="' + key + '"]');
    var qtyEl     = page.querySelector('.shop-cart__qty-num[data-key="' + key + '"]');

    if (lineEl)   lineEl.textContent = formatMoney(unitPrice * qty);
    if (compareEl && unitCompare > unitPrice) {
      compareEl.textContent = formatMoney(unitCompare * qty);
    }
    if (qtyEl) qtyEl.textContent = qty;
  }

  /* ══════════════════════════════════════════════
     AJAX CART CHANGE
     qty === 0 removes the item
     ══════════════════════════════════════════════ */
  function cartChange(key, qty) {
    /* Optimistically update qty number to show responsiveness */
    var qtyEl = page.querySelector('.shop-cart__qty-num[data-key="' + key + '"]');
    if (qtyEl && qty > 0) qtyEl.textContent = qty;

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: qty }),
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      if (qty <= 0) {
        /* Animate row out then remove */
        var itemEl = page.querySelector('.shop-cart__item[data-key="' + key + '"]');
        if (itemEl) {
          itemEl.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
          itemEl.style.opacity = '0';
          itemEl.style.transform = 'translateX(12px)';
          setTimeout(function () {
            if (itemEl.parentNode) itemEl.parentNode.removeChild(itemEl);
          }, 260);
        }
      } else {
        updateLinePrice(key, qty, cart);
      }
      updateSummary(cart);
    })
    .catch(function (err) {
      console.error('[shop-cart] Cart change error:', err);
      /* Revert optimistic update on error */
      if (qtyEl) {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].key === key) {
                qtyEl.textContent = cart.items[i].quantity;
                break;
              }
            }
          });
      }
    });
  }

  /* ══════════════════════════════════════════════
     EVENT DELEGATION
     All button clicks handled at page level
     ══════════════════════════════════════════════ */
  page.addEventListener('click', function (e) {

    /* ── Qty buttons ── */
    var qtyBtn = e.target.closest('.shop-cart__qty-btn');
    if (qtyBtn) {
      var key    = qtyBtn.getAttribute('data-key');
      var action = qtyBtn.getAttribute('data-action');
      var qtyEl  = page.querySelector('.shop-cart__qty-num[data-key="' + key + '"]');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var newQty  = action === 'inc' ? current + 1 : current - 1;
      if (newQty < 0) return; /* don't go below 0 */
      cartChange(key, newQty);
      return;
    }

    /* ── Remove button ── */
    var removeBtn = e.target.closest('.shop-cart__remove-btn');
    if (removeBtn) {
      var key = removeBtn.getAttribute('data-key');
      cartChange(key, 0);
    }

  });

})();
